module.exports = __webpack_public_path__ + "assets/img/warrior-name-3c7aec7b.png";